import * as WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Space Grotesk:100,300,400,600,700']
  }
});
